
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Nagpur District Under-9 & Under-19 Selection Chess Championship 2025</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">

        <div class="row justify-content-between">
            <div class="col-md-12">
                <p><strong>March 30, 2025</strong> The Nagpur District Under-9 & Under-19 Selection Chess Championship for Open and Girls categories concluded successfully at Vivekanand Hall, Shraddha House, Kingsway, near Kasturchand Park, Nagpur. The event was organized by Chess Association Nagpur in association with G.H. Raisoni Sports and Cultural Foundation, MKH Sancheti Group, and Kalpana Prakash Welfare Foundation.
                </p>
                <hr>
                <h5 class="fw-bold">🥇 Winners
                </h5>
                <h6>Under-19 Open Category : </h6>
                <ul class="list-style list-style1">
                  <li><strong>🏆 Champion: </strong> Sharma Sai – 6/6 (Perfect Score)</li>

                  <li><strong>🥈 2nd Place: </strong> Dishank Bajaj – 5 points (tie-break)</li>

                  <li><strong>🥉 3rd Place: </strong> Kushagra Patel – 5 points (tie-break)</li>

                  <li><strong>🎖️ 4th: </strong> Aarit Thakur – 4.5 points</li>

                  <li><strong>🎖️ 5th: </strong> Shaunak Badole – 4.5 points</li>
                </ul>
                <h6>Under-19 Girls Category :</h6>
                  <ul class="list-style list-style1">
                    <li><strong>🏆 Champion: </strong> Shraddha Bajaj – 5.5 points</li>

                    <li><strong>🥈 2nd Place: </strong> Vritika Game – 5 points</li>

                    <li><strong>🥉 3rd Place: </strong> Vidhi Mishrikotkar – 4 points (tie-break)</li>

                    <li><strong>🎖️ 4th: </strong> Anvi Hirde – 4 points (tie-break)</li>
                  </ul>
                  <h6>Under-9 Open Category :</h6>

                <ul class="list-style list-style1">
                  <li><strong>🏆 Champion:</strong> Dhawal Deshmukh – 5.5 points</li>

                  <li><strong>🥈 2nd Place:</strong> Anvit Sontakke – 5 points (tie-break)</li>

                  <li><strong>🥉 3rd Place:</strong> Ridhaan Agrawal – 5 points (tie-break)</li>
                </ul>
                  <h6>Under-9 Girls Category :</h6>
                <ul class="list-style list-style1">
                    <li><strong>🏆 Champion:</strong> Lavanya Mahadik – 6/6 (Perfect Score)</li>

                    <li><strong>🥈 2nd Place:</strong> Gargi Harkare – 5 points</li>

                    <li><strong>🥉 3rd Place:</strong> Anvika Desai – 4 points (tie-break)</li>

                    <li><strong>🎖️ 4th:</strong> Aarohi Agrawal – 4 points (tie-break)</li>
                </ul>
            </div>
            <!-- <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/fide-rapid-rating-chess-tournament.webp"
                        alt="GHRSCF" />

                </div>
            </div> -->
        </div>
        <h5 class="fw-bold"> 🏅 State Representation</h5>

        <p>The top two players from each category will represent Nagpur District at the Maharashtra State Under-9 & Under-19 Open and Girls Chess Championship 2025:</p>


       <ul class="list-style list-style1">
        <li> <strong>U-19 Open: </strong> Sharma Sai & Dishank Bajaj</li>

        <li><strong>U-19 Girls: </strong> Shraddha Bajaj & Vritika Game</li>

        <li> <strong>U-9 Open: </strong> Dhawal Deshmukh & Anvit Sontakke</li>

        <li><strong>U-9 Girls:  </strong>Lavanya Mahadik & Gargi Harkare</li>
       </ul>
        <h5 class="fw-bold"> 🎉 Prize Distribution</h5>

        <p>Prizes were distributed by Ms. Arti Vakil, former chess player and Income Tax Officer, Nagpur, in the presence of Smt. Bindu Joseph, Principal of MKH Sancheti Public School. Also present were Bhushan Shriwas, Secretary, Chess Association Nagpur, and S.S. Soman, MCA Observer Committee Member. The names of the winners were announced by SNA Akash Rewatkar.</p>

        <h5 class="fw-bold"> 👨‍⚖️ Tournament Officials</h5>



       <ul class="list-style list-style1">
        <li><strong>Chief Arbiter: </strong> FA Shiva Iyer</li>

        <li><strong>Assistant Arbiters: </strong> FA Amit Tembhurne, SNA Prayas Ambade, SNA Akash Rewatkar, and Prathamesh Machave</li>


       </ul>
       <div class="section section-md fide-chesscompetition section-banner-bg-1">
        <div class="container">

            <div class="row row-cols-1 row-cols-md-1">
                <div class="col">
                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4 class="fw-bold">Photos</h4>
                                </div>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="gall-ery">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img
                                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img
                                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>


                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </div>
</section>

